import { css } from 'styled-components'

export const GiftTooltipContainerCss = css`
  color: var(--static-black);
  opacity: 1;
  position: absolute;
  visibility: hidden;

  & div[data-tooltip='tooltip'] {
    display: flex;
  }
`
